module.exports = __webpack_public_path__ + "static/media/ic_msg_success.c71eff01.svg";